<app-auth-shell title="Recuperar senha" subtitle="Enviaremos um link no e-mail abaixo.">
  <form role="form" [formGroup]="formForgot" (ngSubmit)="sendResetLink()">
    <div class="auth-field">
      <label class="auth-field__label" for="email">E-mail</label>
      <div class="auth-field__control">
        <input
          id="email"
          type="email"
          formControlName="email"
          class="auth-field__input"
          placeholder="nome@empresa.com"
          autocomplete="email"
          appFocus
        />
      </div>
      @if (formForgot.get('email')?.touched || formForgot.get('email')?.dirty) {
        @if (formForgot.get('email')?.hasError('required')) {
          <div class="auth-field__error">Campo obrigatório</div>
        }
        @if (formForgot.get('email')?.hasError('email')) {
          <div class="auth-field__error">E-mail inválido</div>
        }
      }
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formForgot.valid">Enviar link</button>
  </form>
  <div class="auth-shell__links">
    <p class="auth-shell__links-text">
      Lembrou a senha?
      <a class="auth-link" [routerLink]="['/signin']">Entrar</a>
    </p>
    <p class="auth-shell__legal">
      <a href="https://erpclass.com.br/" target="_blank" rel="noopener noreferrer">SOFTClass</a>
      ·
      <a href="https://erpclass.com.br/" target="_blank" rel="noopener noreferrer">erpclass.com.br</a>
    </p>
  </div>
</app-auth-shell>
